import { render } from "./IconDotsHorizontal.vue?vue&type=template&id=2f68282c"
import script from "./IconDotsHorizontal.vue?vue&type=script&lang=js"
export * from "./IconDotsHorizontal.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/icons/IconDotsHorizontal.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "2f68282c"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('2f68282c', __exports__)) {
    api.reload('2f68282c', __exports__)
  }
  
  module.hot.accept("./IconDotsHorizontal.vue?vue&type=template&id=2f68282c", () => {
    api.rerender('2f68282c', render)
  })

}


export default __exports__